import React from 'react';
import { BrandImageWrapper } from 'pages/TiresPage/TireReferencesSection/TireReferenceCard/Components/BrandImageWrapper';
import { TireBackground } from 'pages/TiresPage/TireReferencesSection/TireReferenceCard/Components/TireBackground';
import { TireBrandImage } from 'pages/TiresPage/TireReferencesSection/TireReferenceCard/TireBrandImage';
import { SBrandLogoOverlay } from 'pages/TiresPage/TireReferencesSection/TireReferenceCard/TireReferenceCard.styled';
import { Box, MarginBox } from 'UI';

interface BrandBlockProps {
  compact?: boolean;
  availableInUserCountry: boolean;
  referenceBrandId?: string;
  renative?: boolean;
}

export function BrandBlock({
  compact,
  availableInUserCountry,
  referenceBrandId,
  renative,
}: Readonly<BrandBlockProps>): JSX.Element | null {
  if (compact) {
    return null;
  }

  return (
    <MarginBox mr={20}>
      <Box width={200} height={160}>
        <BrandImageWrapper availableInUserCountry={availableInUserCountry}>
          <TireBackground />
          <SBrandLogoOverlay>
            <TireBrandImage referenceBrandId={referenceBrandId} width={100} height={30} renative={renative} />
          </SBrandLogoOverlay>
        </BrandImageWrapper>
      </Box>
    </MarginBox>
  );
}
